import { Avatar, AvatarFallback } from "@/components/ui/library/avatar";
import { useActiveDataMutation } from "@/features/leads/hook/useActiveDataMutation";
import { getInitials } from "@/utils/convetors";

export default function AssingnedUsers({ child: childProp }: any) {
  const { lead, child: activeChild } = useActiveDataMutation();

  const childData = activeChild ?? childProp;

  console.log(lead, "lead....");

  const leadUsers = (lead?.leadUsers ?? [])
    .map((u: any) => u?.user)
    .filter(Boolean);

  const childUsers = (childData?.childUsers ?? [])
    .map((u: any) => u?.user)
    .filter(Boolean);

  const seen = new Set<number>();
  const users = [...childUsers, ...leadUsers].filter((u: any) => {
    if (!u?.id || seen.has(u.id)) return false;
    seen.add(u.id);
    return true;
  });

  return (
    <div className="bg-white border border-[#e6e8e7] rounded-[16px] p-4 flex flex-col gap-3">
      <p className="text-b2-mid font-medium text-[#051912] tracking-[-0.32px]">
        Assigned To
      </p>
      {users.length === 0 ? (
        <p className="text-sm text-[#8a918d] tracking-[-0.28px]">
          No users assigned
        </p>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          {users.map((user: any, index: number) => (
            <div
              key={`${user?.name ?? "user"}-${index}`}
              className="flex items-center gap-2 min-w-0"
            >
              <Avatar className="size-9 shrink-0 bg-[#d6ebe3] border-[1.5px] border-dashed border-[#218760]">
                <AvatarFallback className="text-[14px] font-normal text-[#051912] tracking-[-0.56px] leading-[1.35] bg-transparent">
                  {getInitials(user?.name ?? "")}
                </AvatarFallback>
              </Avatar>
              <div className="flex flex-col gap-0.5 flex-1 min-w-0">
                <p className="text-[14px] font-normal text-[#051912] tracking-[-0.56px] leading-[1.35] truncate">
                  {user?.name ?? "Unknown"}
                </p>
                <p className="text-[12px] font-normal text-[#505e59] tracking-[-0.24px] leading-normal truncate">
                  {user?.role?.name ?? ""}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
